import React from 'react';
import BannerImg from "../../images/life-at-tekrevol/life-banner.png";
import {Col, Container, Row} from "react-bootstrap";

function Banner(props) {
    return (
        <div className="services_banner banner_lifeattekrevol"
             style={{backgroundImage: `url(${BannerImg})`}}>
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Job Hunt">
                                <h1>Living & Working From Anywhere</h1>
                            </div>
                            <div
                                className="banner_content_txt listing_flex">
                                <p><strong>At Tekrevol, we foster a culture of inclusivity and collaboration, bringing together passionate technology enthusiasts who strive to drive innovation and unlock their full potential. Our team is dedicated to working together to achieve our goals, pushing the boundaries of what's possible.</strong></p>
                                <ul>
                                    <li>Inclusive Team Culture</li>
                                    <li>Dynamic Work Environment</li>
                                    <li>Technology Enthusiasts</li>
                                    <li>Collaborative Teams</li>
                                </ul>
                            </div>

                        </div>
                    </Col>

                </Row>
            </Container>
        </div>
    );
}

export default Banner;